import { MODERATOR_BANNER } from "../mock/URLs";
import { GetBannerResponse, IBannerItem } from "../types/banner";
import { api } from "./api";

type GetBanner = {
  params?: {
    page?: number;
    page_size?: number;
    search?: string;
  }
}

export const getBanner = async ({params}: GetBanner) => {
  try {
    const {data} = await api.get<GetBannerResponse>(MODERATOR_BANNER, {
      params
    })
    return data;
  } catch (e) {
    throw e
  }
}

export const createBanner = async (values: FormData) => {
  try {
    const {data} = await api.post(MODERATOR_BANNER, values)
    return data;
  } catch (e) {
    throw e
  }
}

export const updateBanner = async (id: number, values: FormData | {}) => {
  try {
    const {data} = await api.patch(`${MODERATOR_BANNER}${id}/`, values)
    return data;
  } catch (e) {
    throw e
  }
}

export const getBannerById = async (id: number) => {
  try {
    const {data} = await api.get<{ data: IBannerItem }>(`${MODERATOR_BANNER}${id}/`)
    return data.data;
  } catch (e) {
    throw e
  }
}